import { IDocumentType } from "@dms/types";

export const getSubTypeName = (subTypeId: string, type: string, documentTypes: IDocumentType[]) => {
    return documentTypes.find(el => el.id === type)?.subTypes.find(el => el.id === subTypeId)?.name || "";
};
